export default __webpack_public_path__ + "static/media/norrtalje-logo.b09ee3fd.svg";